import React from "react";
import Select from 'react-select';
import i18n from "../../../../i18n";
import { Clock, Search, TrendingUp, X } from "lucide-react";
import { HomeBanner } from "../../homeBanner";
import { getAllAuctions, searchAuctions } from "../../../../models/auctions";
import { getCategories, getCategoriesNew } from "../../../../models/categories";
import { getOrganizations } from "../../../../models/organization";
import { CustomTitle } from "../../../helpers/customTitle";
import Lightbox from "react-awesome-lightbox";
import { Pagination } from "react-bootstrap";
import { MzadLoader } from "../../../helpers/mzadLoader";
import { AuctionRowGrouped } from "../../helpers/auctionRowGrouped";
import { AuctionCard } from "../../helpers/auctionCard";

let current_lng = localStorage.getItem('I18N_LANGUAGE');
export class Auctions extends React.Component {
  constructor() {
    super();
    this.state = {
      total: 0,
      pagination: {
        limit: 15, // Changed from 30 to 15 as per your requirement
        page: 1,
      },
      catArrs: [],
      subCatArrs: [],
      categories: [],
      selectedCategories: [],
      orgArrs: [],
      organizations: [],
      auctions: [],
      is_loading: false,
      is_cat_loading: false,
      lightboxImages: [],
      is_active_light_box: false,
      grid: false,
      section: '',
      type: '',
      category: '',
      organization: '',
      expand_orgs: false,
      expand_cats: false,
      input: {
        search_text: '',
        organization: '',
        fdate: '',
        tdate: ''
      },
      startDate: "",
      endDate: "",
      vehicle_categories: [],
      isOpen: false,
      expandedSections: {
        category: true,
        vehicleType: true,
        make: false,
        model: false,
        endDate: false,
        odometer: false,
        priceRange: false,
        yearRange: false
      },
      searchSuggestions: [],
      showSuggestions: false,
      searchTimeout: null,
      recentSearches: [],
      popularSearches: ['car', 'electronics', 'furniture', 'real estate', 'jewelry'],
      isSearchFocused: false
    };
    this.getAllAuctionsList = this.getAllAuctionsList.bind(this);
    this.getImagePopup = this.getImagePopup.bind(this);
    this.applyFilters = this.applyFilters.bind(this);
    this.createCategory = this.createCategory.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleSuggestionClick = this.handleSuggestionClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    let urlSearchParams = new URLSearchParams(window.location.search);
    let params = Object.fromEntries(urlSearchParams.entries());

    // Set pagination from URL if available
    if (params.page) {
      this.setState(prevState => ({
        pagination: {
          ...prevState.pagination,
          page: parseInt(params.page)
        }
      }));
    }

    this.loadAllCategories(params);
    this.loadAllOrganizations(params);
    this.getAllAuctionsList(params);
    if (params.sec === 'vehicle') {
      this.loadVehicleCategories();
    }

    // Load recent searches from localStorage
    const savedRecentSearches = localStorage.getItem('recentSearches');
    if (savedRecentSearches) {
      this.setState({ recentSearches: JSON.parse(savedRecentSearches) });
    }

    // Add click outside listener to close suggestions
    document.addEventListener('click', this.handleClickOutside);
  }

  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener('click', this.handleClickOutside);
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
  }

  handleClickOutside = (e) => {
    if (!e.target.closest('.mz_search_wrapper_bcde_901')) {
      this.setState({
        showSuggestions: false,
        isSearchFocused: false
      });
    }
  };

  handleChange(event) {
    let input = this.state.input;
    input[event.target.name] = event.target.value;
    this.setState({ input });
  }

  handleDateChange(date, name) {
    let input = this.state.input;
    if (date) {
      const dateObject = new Date(date);
      const day = dateObject.getDate();
      const month = dateObject.getMonth() + 1;
      const year = dateObject.getFullYear();
      const formattedDay = day < 10 ? `0${day}` : day;
      const formattedMonth = month < 10 ? `0${month}` : month;
      const formattedDate = `${year}-${formattedMonth}-${formattedDay}`.toString();
      input[name] = formattedDate;
      this.setState({ input, [name]: date });
    } else {
      input[name] = '';
      this.setState({ input, [name]: null });
    }
  }

  handleSearchInputChange = (e) => {
    const value = e.target.value;
    let input = this.state.input;
    input.search_text = value;
    this.setState({ input });

    // Clear existing timeout
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }

    if (value.length > 0) {
      // Show suggestions immediately when typing starts
      this.setState({ showSuggestions: true });

      if (value.length > 1) {
        // Set new timeout for debouncing API calls
        const timeout = setTimeout(() => {
          this.fetchSearchSuggestions(value);
        }, 200);

        this.setState({ searchTimeout: timeout });
      } else {
        // Clear API suggestions but keep dropdown open for recent/popular searches
        this.setState({ searchSuggestions: [] });
      }
    } else {
      this.setState({
        searchSuggestions: [],
        showSuggestions: this.state.isSearchFocused // Keep open if focused but empty
      });
    }
  };

  fetchSearchSuggestions = async (query) => {
    try {
      const response = await searchAuctions(`text=${query}&limit=8&lang=${current_lng}`);
      if (response && response.data) {
        this.setState({
          searchSuggestions: response.data
        });
      }
    } catch (error) {
      console.error('Error fetching search suggestions:', error);
      this.setState({
        searchSuggestions: []
      });
    }
  };

  handleSuggestionClick = (suggestion, type = 'auction') => {
    let searchText = '';

    if (type === 'auction') {
      searchText = suggestion.title || suggestion.title_ar;
    } else if (type === 'recent') {
      searchText = suggestion;
    } else if (type === 'popular') {
      searchText = suggestion;
    }

    let input = this.state.input;
    input.search_text = searchText;

    // Add to recent searches
    this.addToRecentSearches(searchText);

    this.setState({
      input,
      showSuggestions: false,
      searchSuggestions: [],
      isSearchFocused: false
    }, () => {
      this.applyFilters();
    });
  };

  addToRecentSearches = (searchTerm) => {
    const recentSearches = [...this.state.recentSearches];

    // Remove if already exists
    const existingIndex = recentSearches.indexOf(searchTerm);
    if (existingIndex > -1) {
      recentSearches.splice(existingIndex, 1);
    }

    // Add to beginning
    recentSearches.unshift(searchTerm);

    // Keep only last 5 searches
    const updatedSearches = recentSearches.slice(0, 5);

    this.setState({ recentSearches: updatedSearches });
    localStorage.setItem('recentSearches', JSON.stringify(updatedSearches));
  };

  clearRecentSearches = () => {
    this.setState({ recentSearches: [] });
    localStorage.removeItem('recentSearches');
  };

  handleSearch = (e) => {
    if (e.key === 'Enter' || e.type === 'click') {
      if (this.state.input.search_text.trim()) {
        this.addToRecentSearches(this.state.input.search_text.trim());
      }

      this.setState({
        showSuggestions: false,
        searchSuggestions: [],
        isSearchFocused: false,
        pagination: {
          ...this.state.pagination,
          page: 1 // Reset to first page on new search
        }
      });
      this.applyFilters();
    }
  };

  handleSearchFocus = () => {
    this.setState({
      isSearchFocused: true,
      showSuggestions: true
    });
  };

  handleSearchBlur = () => {
    // Delay hiding to allow for clicks on suggestions
    setTimeout(() => {
      if (!this.state.isSearchFocused) {
        this.setState({ showSuggestions: false });
      }
    }, 200);
  };

  async loadAllCategories(params) {
    this.setState({ is_cat_loading: true });
    if (typeof params.category !== 'undefined') {
      var category = params.category;
      this.setState({
        catArrs: [parseInt(category)],
        selectedCategories: [parseInt(category)]
      });
    }
    const response = await getCategoriesNew('active=1');
    if (response) {
      let categories = response.data;
      console.log(categories);
      this.setState({ categories });
      this.setState({ is_cat_loading: false });
    }
  }

  async loadVehicleCategories() {
    const response = await getCategories('vehicles=1');
    if (response) {
      let vehicle_categories = response.data;
      this.setState({ vehicle_categories });
    }
  }

  async loadAllOrganizations(params) {
    this.setState({ is_org_loading: true });
    if (typeof params.organization !== 'undefined') {
      var org = params.organization;
      this.setState({
        orgArrs: [parseInt(org)],
        input: {
          ...this.state.input,
          organization: org
        }
      });
    }
    let q = params.type === 'active' ? 'is_active=1' : '';
    const response = await getOrganizations(q);
    if (response) {
      let organizations = response.data;
      this.setState({ organizations });
      this.setState({ is_org_loading: false });
    }
  }

  async getAllAuctionsList(params = {}) {
    this.setState({ is_loading: true });
    let q = '';

    // Use params from function call or fall back to state
    const section = params.sec || this.state.section;
    const type = params.type || this.state.type;
    const category = params.category || this.state.category;
    // Fix: Use organization from params or input.organization
    const organization = params.organization || this.state.input.organization;
    const search_text = params.search_text || this.state.input.search_text;

    if (typeof this.state.pagination.limit !== 'undefined') {
      q += 'limit=' + this.state.pagination.limit;
    }
    if (typeof this.state.pagination.page !== 'undefined') {
      q += '&page=' + this.state.pagination.page;
    }
    if (section) {
      q += '&section=' + section;
    }
    if (type) {
      q += '&type=' + type;
    }
    if (category) {
      q += '&category=' + category;
    }
    // Fix: Add organization to query string
    if (organization) {
      q += '&organization=' + organization;
    }
    if (search_text) {
      q += '&text=' + encodeURIComponent(search_text);
    }
    q += '&lang=' + current_lng;

    let { fdate, tdate } = this.state.input;
    if (fdate) {
      q += '&fdate=' + fdate;
    }
    if (tdate) {
      q += '&tdate=' + tdate;
    }

    this.setState({
      section: section,
      type: type,
      category: category,
    });

    const response = await getAllAuctions(q);
    if (response) {
      let { meta, data } = response;
      this.setState({
        auctions: data,
        is_loading: false,
        total: meta.total
      });

      // Scroll to top when page changes
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  createCategory(id, sub = false) {
    if (sub) {
      var subCatArrs = this.state.catArrs;
      if (subCatArrs.includes(id)) {
        const index = subCatArrs.indexOf(parseInt(id));
        if (index > -1) {
          subCatArrs.splice(index, 1);
        }
      } else {
        subCatArrs.push(parseInt(id));
      }
      this.setState({ subCatArrs: subCatArrs });
      this.applyFilters();
    } else {
      if (!id) {
        this.setState({
          catArrs: [],
          selectedCategories: []
        });
        this.applyFilters();
        return;
      }
      var catArrs = this.state.catArrs;
      let selectedCategories = [...this.state.selectedCategories];

      if (catArrs.includes(id)) {
        const index = catArrs.indexOf(parseInt(id));
        if (index > -1) {
          catArrs.splice(index, 1);
        }
        // Also remove from selectedCategories for the filter panel
        const selectedIndex = selectedCategories.indexOf(parseInt(id));
        if (selectedIndex > -1) {
          selectedCategories.splice(selectedIndex, 1);
        }
      } else {
        catArrs.push(parseInt(id));
        selectedCategories.push(parseInt(id));
      }
      this.setState({
        catArrs: catArrs,
        selectedCategories: selectedCategories
      });
      this.applyFilters();
    }
  }

  applyFilters() {
    var { type, section, pagination, input } = this.state;
    var { catArrs } = this.state;

    var cats = catArrs.join(',');
    if (catArrs.length < 1) {
      cats = '';
    }

    pagination.limit = 15;
    pagination.page = 1; // Reset to first page when applying filters
    this.setState({ pagination });

    this.setState({
      category: cats,
      vehicle_category: cats,
      type: type,
      section: section,
    });

    this.getAllAuctionsList({
      sec: section,
      type: type,
      category: cats,
      vehicle_category: cats,
      organization: input.organization, // Make sure this is passed correctly
      search_text: input.search_text,
    });

    // Close the filter panel and suggestions after applying
    this.setState({
      isOpen: false,
      showSuggestions: false,
      isSearchFocused: false
    });
  }

  getImagePopup(active, images) {
    let lightboxImages = [];
    if (images) {
      images.forEach(function (arrayItem) {
        lightboxImages.push({
          url: arrayItem.image,
        });
      });
      this.setState({
        is_active_light_box: active,
        lightboxImages: lightboxImages,
      });
    }
  }

  handlePageChange = (pageNumber) => {
    let { pagination } = this.state;
    pagination.page = pageNumber;
    this.setState({ pagination }, () => {
      this.getAllAuctionsList();
    });
  };

  // Custom pagination component render
  // Custom pagination component render
  renderPagination = () => {
    const { total, pagination, is_loading } = this.state;
    const totalPages = Math.ceil(total / pagination.limit);

    if (totalPages <= 1) return null;

    let items = [];
    const maxVisible = 5;
    let startPage = Math.max(1, pagination.page - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);

    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }

    // First page button
    if (pagination.page > 1) {
      items.push(
        <li
          key="first"
          className="mz_pagination_nav_9012"
          onClick={() => this.handlePageChange(1)}
        >
          <svg className="mz_nav_icon_7890" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 17L13 12L18 7M11 17L6 12L11 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </li>
      );
    }

    // Previous button
    if (pagination.page > 1) {
      items.push(
        <li
          key="prev"
          className="mz_pagination_nav_9012"
          onClick={() => this.handlePageChange(pagination.page - 1)}
        >
          <svg className="mz_nav_icon_7890" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M15 18L9 12L15 6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </li>
      );
    }

    // Show ellipsis if needed
    if (startPage > 1) {
      items.push(
        <li key="ellipsis1" className="mz_pagination_ellipsis_2345">
          ...
        </li>
      );
    }

    // Page numbers
    for (let number = startPage; number <= endPage; number++) {
      items.push(
        <li
          key={number}
          className={`mz_pagination_item_1234 ${number === pagination.page ? 'mz_active_page_5678' : ''}`}
          onClick={() => this.handlePageChange(number)}
        >
          {number}
        </li>
      );
    }

    // Show ellipsis if needed
    if (endPage < totalPages) {
      items.push(
        <li key="ellipsis2" className="mz_pagination_ellipsis_2345">
          ...
        </li>
      );
    }

    // Next button
    if (pagination.page < totalPages) {
      items.push(
        <li
          key="next"
          className="mz_pagination_nav_9012"
          onClick={() => this.handlePageChange(pagination.page + 1)}
        >
          <svg className="mz_nav_icon_7890" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M9 18L15 12L9 6" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </li>
      );
    }

    // Last page button
    if (pagination.page < totalPages) {
      items.push(
        <li
          key="last"
          className="mz_pagination_nav_9012"
          onClick={() => this.handlePageChange(totalPages)}
        >
          <svg className="mz_nav_icon_7890" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M6 17L11 12L6 7M13 17L18 12L13 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </li>
      );
    }

    return (
      <div className={`mz_pagination_wrapper_2024 ${is_loading ? 'mz_pagination_loading_5678' : ''}`}>
        <ul className="mz_pagination_container_7890">
          {items}
        </ul>
        <div className="mz_pagination_info_6789">
          <span className="mz_info_text_3456">
            Showing <span className="mz_info_highlight_9012">
              {((pagination.page - 1) * pagination.limit) + 1}
            </span> - <span className="mz_info_highlight_9012">
              {Math.min(pagination.page * pagination.limit, total)}
            </span> of <span className="mz_info_highlight_9012">{total}</span> results
          </span>
        </div>
      </div>
    );
  };

  showResults = () => {
    const { startDate, endDate, selectedCategories, input } = this.state;

    // Update the category filter based on selected categories
    const cats = selectedCategories.join(',');

    // Update date filters - preserve existing organization
    const updatedInput = {
      ...input,
      fdate: startDate,
      tdate: endDate
      // organization is already in input
    };

    this.setState({
      catArrs: selectedCategories,
      category: cats,
      input: updatedInput,
      pagination: {
        ...this.state.pagination,
        page: 1 // Reset to first page
      }
    }, () => {
      this.applyFilters();
    });

    console.log({
      categories: selectedCategories,
      start_date: startDate,
      end_date: endDate,
      organization: input.organization
    });
  }

  toggleFilter = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };

  toggleSection = (section) => {
    this.setState(prevState => ({
      expandedSections: {
        ...prevState.expandedSections,
        [section]: !prevState.expandedSections[section]
      }
    }));
  };

  handleCategoryChange = (categoryId) => {
    this.setState((prevState) => {
      const isSelected = prevState.selectedCategories.includes(categoryId);
      let newSelectedCategories;

      if (isSelected) {
        newSelectedCategories = prevState.selectedCategories.filter((id) => id !== categoryId);
      } else {
        newSelectedCategories = [...prevState.selectedCategories, categoryId];
      }

      // Also update catArrs for consistency with the existing filter system
      const newCatArrs = newSelectedCategories;

      return {
        selectedCategories: newSelectedCategories,
        catArrs: newCatArrs
      };
    }, () => {
      // This callback runs after state is updated
      this.applyFilters();
    });
  };

  clearAllFilters = () => {
    this.setState({
      selectedCategories: [],
      catArrs: [],
      startDate: "",
      endDate: "",
      input: {
        ...this.state.input,
        fdate: '',
        tdate: '',
        search_text: '',
        organization: ''
      },
      searchSuggestions: [],
      showSuggestions: false,
      isSearchFocused: false,
      pagination: {
        ...this.state.pagination,
        page: 1 // Reset to first page
      }
    }, () => {
      this.applyFilters();
    });
  };

  render() {
    let { categories, vehicle_categories, organizations, auctions, catArrs, subCatArrs, isOpen, expandedSections, selectedCategories, searchSuggestions, showSuggestions, recentSearches, popularSearches, isSearchFocused, input, total, pagination } = this.state;

    const hasSearchText = input.search_text.length > 0;
    const showRecentSearches = !hasSearchText && recentSearches.length > 0;
    const showPopularSearches = !hasSearchText && popularSearches.length > 0;
    const showAuctionResults = hasSearchText && searchSuggestions.length > 0;
    const totalPages = Math.ceil(total / pagination.limit);

    return (
      <React.Fragment>

        {/* Filter Panel with Unique Classes */}
        <div
          className={`mz_filter_overlay_xyz_2024 ${!isOpen ? 'mz_state_hidden_9876' : ''}`}
          onClick={(e) => e.target === e.currentTarget && this.toggleFilter()}
        >
          <div className="mz_panel_container_abcd_789 mz_filter_panel_animate_7890">
            <div className="mz_header_wrapper_efgh_456">
              <h2>Filters</h2>
              <button className="mz_close_btn_ijkl_123" onClick={this.toggleFilter}>
                <X size={24} />
              </button>
            </div>

            <div className="mz_content_area_mnop_321">
              {/* Category Section */}
              <div className="mz_filter_block_qrst_654">
                <div className="mz_block_header_uvwx_987">
                  <h3>Category</h3>
                </div>
                <div className="mz_category_grid_yzab_246">
                  {categories.map(category => (
                    <button
                      key={category.id}
                      className={`mz_category_item_cdef_802 ${selectedCategories.includes(category.id) ? 'mz_selected_state_ghij_573' : ''}`}
                      onClick={() => this.handleCategoryChange(category.id)}
                    >
                      <div className="mz_category_content_pqrs_648">
                        <span className="mz_category_name_kmlo_419">
                          {current_lng === "ar" ? category.category_name_ar : category.category_name}
                        </span>
                      </div>
                      <span className="mz_category_count_tuvw_285">
                        ({category.auctions_count})
                      </span>
                    </button>
                  ))}
                </div>
              </div>

              {/* Date Range Section */}
              <div className="mz_filter_block_qrst_654">
                <div className="mz_block_header_uvwx_987">
                  <h3>Date Range</h3>
                </div>
                <div className="mz_date_range_xyza_731">
                  <div className="mz_date_field_bcde_492">
                    <label>Start Date</label>
                    <input
                      type="date"
                      className="mz_date_input_fghi_157"
                      value={this.state.startDate}
                      onChange={(e) => this.setState({ startDate: e.target.value })}
                    />
                  </div>
                  <div className="mz_date_field_bcde_492">
                    <label>End Date</label>
                    <input
                      type="date"
                      className="mz_date_input_fghi_157"
                      value={this.state.endDate}
                      onChange={(e) => this.setState({ endDate: e.target.value })}
                    />
                  </div>
                </div>
              </div>

              {/* Seller Section */}
              <div className="mz_filter_block_qrst_654">
                <div className="mz_block_header_uvwx_987">
                  <h3>{i18n.t('seller')}</h3>
                </div>
                <div className="mz_select_container_jklm_638">
                  <Select
                    isMulti
                    name="organization"
                    id="groupSelect"
                    options={organizations.map((item) => ({
                      value: item.id,
                      label: item.organization_name
                    }))}
                    value={(this.state.input.organization || []).map((id) => {
                      const g = organizations.find((item) => item.id === id);
                      return g ? { value: g.id, label: g.organization_name } : null;
                    }).filter(Boolean)}
                    onChange={(selected) => {
                      this.setState((prevState) => ({
                        input: {
                          ...prevState.input,
                          organization: selected ? selected.map((opt) => opt.value) : []
                        }
                      }));
                    }}
                    classNamePrefix="mz_react_select"
                    placeholder={i18n.t('select_seller')}
                    classNames={{
                      control: () => 'mz_react_select_control_nopq_274',
                      placeholder: () => 'mz_react_select_placeholder_rstu_593',
                      option: () => 'mz_react_select_option_vwxy_826',
                      multiValue: () => 'mz_react_select_multi_value_zabc_371',
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="mz_footer_actions_defg_504">
              <button className="mz_action_button_hijk_739 mz_clear_type_lmno_862" onClick={this.clearAllFilters}>
                Clear All
              </button>
              <button className="mz_action_button_hijk_739 mz_show_type_pqrs_217" onClick={this.showResults}>
                Show Results
              </button>
            </div>
          </div>
        </div>

        {/* Toggle Filter Button */}
        <button
          className={`mz_floating_toggle_tuvw_485 ${isOpen ? 'mz_open_state_xyza_638' : ''}`}
          onClick={this.toggleFilter}
        >
          <i className="fa fa-filter" /> Filters
        </button>

        {/* <HomeBanner callbackForSupport={this.props.callbackForSupport} /> */}

        <div className="row overflow-hidden" id="auctions-list">
          <div className="section-title center-block text-center auction-list-section">
            <CustomTitle
              title={
                this.state.type === 'active' ? i18n.t('active_auctions') :
                  this.state.type === 'upcoming' ? i18n.t('upcoming_auctions') :
                    this.state.type === 'previous' ? i18n.t('previous_auctions') :
                      this.state.type === 'featured' ? i18n.t('featured_auctions') :
                        (this.state.section === 'main' && typeof this.state.type === 'undefined') ? i18n.t('auctions') :
                          this.state.section === 'vehicle' ? i18n.t('vehicle_auctions') :
                            ''
              }
              icon="ri_auction-fill.png"
              icon_type="img"
              count={this.state.total}
              need_mzad_icon={true}
            />
          </div>

          <section className="sptb mt-3">
            <div className="container">
              <div className="row">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className=" mb-0">
                    <div className>
                      <div className="item2-gl " id="auction-grouped">

                        <div className="button-sort-section m-auto" style={{ width: '100%' }}>
                          <div className="dropdown search-section-dropdown">
                            <button
                              className="btn btn-secondary dropdown-toggle burger-menu"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              onClick={() => {
                                this.setState({
                                  show_cat_dd: !this.state.show_cat_dd,
                                });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/burger menu.png'}
                                width="30"
                                alt=""
                              />
                            </button>
                            <ul
                              className={
                                this.state.show_cat_dd ? 'dropdown-menu d-block' : 'dropdown-menu'
                              }
                            >
                              {categories.map((item, i) => {
                                return (
                                  <li key={item.id}>
                                    <a
                                      className={
                                        catArrs.includes(item.id)
                                          ? 'dropdown-item active'
                                          : 'dropdown-item'
                                      }
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        this.createCategory(item.id);
                                        this.setState({
                                          show_cat_dd: false,
                                        });
                                      }}
                                    >
                                      {current_lng === 'ar'
                                        ? item.category_name_ar
                                        : item.category_name}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                          <div className="buttons-section justify-content-start">
                            <button
                              className="sort-button sbtn-1"
                              onClick={this.toggleFilter}
                            >
                              <i className="fa fa-filter" width="20" style={{ color: "white" }}> </i>
                            </button>
                            All Filters
                          </div>
                          <div className="sort-section">

                            {/* Search Component with Unique Classes */}
                            <div className="mz_search_wrapper_bcde_901">
                              <div className="mz_search_field_group_fghi_234">
                                <Search className="mz_search_icon_left_mnop_890" />
                                <input
                                  type="text"
                                  className="mz_search_field_ijkl_567"
                                  placeholder={i18n.t('search_by_name_loc_seller')}
                                  value={this.state.input.search_text}
                                  onChange={this.handleSearchInputChange}
                                  onKeyPress={this.handleSearch}
                                  onFocus={this.handleSearchFocus}
                                  onBlur={this.handleSearchBlur}
                                />
                                {input.search_text && (
                                  <Search
                                    className="mz_search_icon_action_pqrs_234"
                                    onClick={this.handleSearch}
                                  />
                                )}
                              </div>

                              {/* Suggestions Dropdown */}
                              {showSuggestions && isSearchFocused && (
                                <div className="mz_suggestions_dropdown_tuvw_567">

                                  {/* Auction Results */}
                                  {showAuctionResults && (
                                    <div className="mz_suggestion_category_xyza_789">
                                      <div className="mz_category_header_bcde_123">
                                        <Search className="mz_icon_custom_fghi_789 mz_icon_search_pqrs_789" />
                                        Auction Results
                                      </div>
                                      {searchSuggestions.map((suggestion, index) => (
                                        <div
                                          key={suggestion.id || index}
                                          className="mz_suggestion_item_fghi_456"
                                          onClick={() => this.handleSuggestionClick(suggestion, 'auction')}
                                        >
                                          {suggestion.images && suggestion.images[0] && (
                                            <img
                                              src={suggestion.images[0].image}
                                              alt=""
                                              className="mz_suggestion_thumb_tuvw_789"
                                              onError={(e) => {
                                                e.target.style.display = 'none';
                                              }}
                                            />
                                          )}
                                          <div>
                                            <div className="mz_suggestion_title_ijkl_789">
                                              {current_lng === 'ar' ? suggestion.title_ar : suggestion.title}
                                            </div>
                                            <div className="mz_suggestion_meta_mnop_123">
                                              <span>
                                                {suggestion.category_name && (
                                                  current_lng === 'ar' ? suggestion.category_name_ar : suggestion.category_name
                                                )}
                                              </span>
                                              {suggestion.current_amount && (
                                                <span className="mz_suggestion_price_pqrs_456">
                                                  ${suggestion.current_amount}
                                                </span>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* Recent Searches */}
                                  {showRecentSearches && (
                                    <div className="mz_suggestion_category_xyza_789">
                                      <div className="mz_category_header_bcde_123">
                                        <Clock className="mz_icon_custom_fghi_789 mz_icon_recent_ijkl_123" />
                                        Recent Searches
                                        <button
                                          className="mz_clear_recent_btn_bcde_456"
                                          onClick={this.clearRecentSearches}
                                        >
                                          Clear
                                        </button>
                                      </div>
                                      {recentSearches.map((search, index) => (
                                        <div
                                          key={index}
                                          className="mz_suggestion_item_fghi_456"
                                          onClick={() => this.handleSuggestionClick(search, 'recent')}
                                        >
                                          <Clock className="mz_icon_custom_fghi_789 mz_icon_recent_ijkl_123" />
                                          {search}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* Popular Searches */}
                                  {showPopularSearches && (
                                    <div className="mz_suggestion_category_xyza_789">
                                      <div className="mz_category_header_bcde_123">
                                        <TrendingUp className="mz_icon_custom_fghi_789 mz_icon_trending_mnop_456" />
                                        Popular Searches
                                      </div>
                                      {popularSearches.map((search, index) => (
                                        <div
                                          key={index}
                                          className="mz_suggestion_item_fghi_456"
                                          onClick={() => this.handleSuggestionClick(search, 'popular')}
                                        >
                                          <TrendingUp className="mz_icon_custom_fghi_789 mz_icon_trending_mnop_456" />
                                          {search}
                                        </div>
                                      ))}
                                    </div>
                                  )}

                                  {/* No Results */}
                                  {hasSearchText && searchSuggestions.length === 0 && (
                                    <div className="mz_empty_state_xyza_123">
                                      No results found for "{input.search_text}"
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>

                            <button
                              className={
                                this.state.grid
                                  ? 'sort-button sbtn-1 d-mob-none'
                                  : 'sort-button sbtn-2 d-mob-none'
                              }
                              onClick={() => {
                                this.setState({ grid: true });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/grid.png'}
                                width="20"
                                alt="sort"
                                className={this.state.grid ? 'grid-invert' : ''}
                              />
                            </button>
                            <button
                              className={
                                !this.state.grid
                                  ? 'sort-button sbtn-1 d-mob-none'
                                  : 'sort-button sbtn-2 d-mob-none'
                              }
                              onClick={() => {
                                this.setState({ grid: false });
                              }}
                            >
                              <img
                                src={process.env.PUBLIC_URL + '/assets/images/burger menu.png'}
                                width="20"
                                alt="sort"
                                className={!this.state.grid ? '' : 'grid-invert'}
                              />
                            </button>
                          </div>
                        </div>

                        {/* Auction listing section */}
                        <div className="tab-content rounded-4 mb-3 mt-3">
                          <div className="tab-pane active" id="tab-11">
                            <MzadLoader loading={this.state.is_loading} size="md" />

                            
                            {total > pagination.limit && this.renderPagination()}

                            <div>
                              {!this.state.is_loading &&
                                !this.state.grid &&
                                auctions.length > 0 &&
                                auctions.map((item, i) => {
                                  let _data = {
                                    auction: item,
                                    auctionId: item.id,
                                    total_items: auctions.length,
                                    company: 'Mzadcom',
                                    price: item.start_amount,
                                    title: item.title,
                                    title_ar: item.title_ar,
                                    description: 'Diesel Generators',
                                    curr_amount: item.current_amount,
                                    end_date: item.end_date_formatted,
                                    start_date: item.start_date_formatted,
                                    images: item.images,
                                    total_views: item.total_views,
                                    type: this.state.type,
                                    can_bid: false,
                                    status: item.status,
                                  };

                                  return (
                                    <AuctionRowGrouped
                                      key={i}
                                      {..._data}
                                      getImagePopup={this.getImagePopup}
                                    />
                                  );
                                })}
                            </div>

                            <div className="row">
                              {!this.state.is_loading &&
                                this.state.grid &&
                                auctions.length > 0 &&
                                auctions.map((item, i) => {
                                  let _data = {
                                    auction: item,
                                    auctionId: item.id,
                                    total_items: auctions.length,
                                    company: 'Mzadcom',
                                    price: item.start_amount,
                                    title: item.title,
                                    title_ar: item.title_ar,
                                    description: 'Diesel Generators',
                                    curr_amount: item.current_amount,
                                    end_date: item.end_date_formatted,
                                    start_date: item.start_date_formatted,
                                    images: item.images,
                                    total_views: item.total_views,
                                    type: this.state.type,
                                    can_bid: false,
                                    status: item.status,
                                  };

                                  return (
                                    <div className="col-md-4" key={i}>
                                      <AuctionCard
                                        {..._data}
                                        getImagePopup={this.getImagePopup}
                                        isDetailsPage={true}
                                      />
                                    </div>
                                  );
                                })}
                            </div>

                            {!this.state.is_loading && !auctions.length && (
                              <div className="help text-danger text-center">
                                {i18n.t('no_auctions_found')}
                              </div>
                            )}
                          </div>
                        </div>

                        {/* Pagination Component */}
                        {total > pagination.limit && this.renderPagination()}

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {this.state.is_active_light_box && (
          <Lightbox
            images={this.state.lightboxImages}
            onClose={() => {
              this.setState({ is_active_light_box: false });
            }}
          />
        )}
      </React.Fragment>
    );
  }
}